(function() { window.GUID_76488897_c423_48e3_a651_1ba7ed2435f6 = { getGuid: function() { return "76488897-c423-48e3-a651-1ba7ed2435f6"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let ChartState;
        (function (ChartState) {
            ChartState[ChartState["Initializing"] = 1] = "Initializing";
            ChartState[ChartState["Unready"] = 2] = "Unready";
            ChartState[ChartState["Ready"] = 3] = "Ready";
            ChartState[ChartState["Running"] = 4] = "Running";
            ChartState[ChartState["Stopping"] = 5] = "Stopping";
            ChartState[ChartState["Stopped"] = 6] = "Stopped";
            ChartState[ChartState["Error"] = 7] = "Error";
            ChartState[ChartState["Finished"] = 8] = "Finished";
            ChartState[ChartState["Destroying"] = 9] = "Destroying";
        })(ChartState = Enumeration.ChartState || (Enumeration.ChartState = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ChartState.pre.js.map
